// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2VzKy","clinicsSelect":"TableHeading_clinicsSelect__27lo_"};